import { createSelector } from '@reduxjs/toolkit';
import {
  selectOptionsPages,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
} from '../project/projectSelectros';

export const selectDefaultPagesTotal = createSelector(
  selectOptionsPages,
  (options) => {
    return {
      discount: 0,
      totalPricePages: options.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0)
    }
  }
);

export const selectDefaultOptionsTotal = createSelector(
  selectDefaultPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectDefaultTotal = createSelector(
  selectDefaultPagesTotal,
  selectDefaultOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectDefaultEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectDefaultDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});

export const selectDefaultTotalForAsap = createSelector(
    selectDefaultTotal,
    (totalPrice) => (totalPrice / 2)
);
